module.exports = __webpack_public_path__ + "static/beliefs-doubts-83a9b41fcfe0f47a20b9d3b2682dbeaa.jpg";